<template>
  <div class="container">
    <div
      class="close-btn"
      style="z-index: 100"
      @click="close"
    >
      <!-- <i class="el-icon-close"></i> -->
      <iconfont
        name="#icon20-12guanbianniujiaohu"
        font-size="12px"
      ></iconfont>
    </div>
    <div class="wb-tool-works-diaolog-body">
      <loading-mask v-if="checking"></loading-mask>
      <div class="title">
        请选择视频
      </div>

      <!-- :style="{ visibility: dataList.length > 0 || formatFolderList.length > 1 ? 'visible' : 'hidden' }" -->
      <div class="head">
        <el-radio-group
          v-model="videoType"
          @input="typeChange"
        >
          <el-radio-button
            :label="1"
            size="small"
          >
            来画动画
          </el-radio-button>
          <el-radio-button
            :label="0"
            size="small"
          >
            来画视频
          </el-radio-button>
        </el-radio-group>
        <bench-select
          v-if="formatFolderList.length > 1"
          ref="benchSelect"
          v-model="folderId"
          class="wb-tool-works-diaolog-select"
          :options="formatFolderList"
          :width="'110px'"
          placeholder="默认"
          @change="folderChange"
        ></bench-select>
      </div>

      <load-state
        class="wb-tool-works-diaolog-state"
        :load-flag="loadState"
      ></load-state>
      <div
        v-if="dataList.length > 0 || loadState != 3"
        class="wb-tool-works-diaolog-container"
      >
        <div class="wb-tool-works-diaolog-list">
          <div
            v-for="(item, index) in dataList"
            :key="index"
            :class="['wb-tool-works-diaolog-card', cardClass]"
          >
            <el-checkbox
              class="card-select wb-tool-works-diaolog-select"
              :value="item.selected"
              @change="changeSelect(item)"
            ></el-checkbox>
            <div :class="['card-poster', type == '1' ? 'card-poster-video' : '']">
              <!--视频-->
              <img
                class="poster-img-v"
                :src="$.handleAssetsUrl(getScreen(item) || getThumbnailUrl(item))"
                alt
              >
              <img
                class="poster-img-v-c"
                :src="$.handleAssetsUrl(getScreen(item) || getThumbnailUrl(item))"
                alt
              >
              <duration
                v-if="item.duration || item.during"
                class="card-during"
                :duration="$.secToMin(item.duration || item.during || 0)"
              ></duration>
            </div>
            <div
              v-if="type != '4'"
              class="card-title"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>

      <div class="wb-tool-works-diaolog-footer">
        <bench-btn
          size="120px"
          type="plain"
          label="取消"
          @click="cancel"
        ></bench-btn>
        <bench-btn
          :disabled="dataList.length == 0"
          size="120px"
          label="确定"
          @click="submit"
        ></bench-btn>
      </div>
    </div>
  </div>
</template>
<script>
import benchSelect from '@/components/global/benchSelect.vue';
import benchBtn from '@/components/global/benchBtn.vue';
import duration from '@/components/global/cardDuration.vue';
import loadState from '@/components/global/loadState.vue';
import LoadingMask from './loadingMask.vue';
import contentMixin from './contentMixin';

export default {
  name: 'WorksContent',
  components: {
    benchSelect,
    benchBtn,
    duration,
    loadState,
    LoadingMask
  },
  mixins: [contentMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    url: {
      //素材url
      type: String,
      default: ''
    },
    type: {
      //素材类型
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: ''
    },
    folderInfo: {
      //是否在文件夹内部，如果存在，就在文件夹内部，直接移入文件夹
      type: Object,
      default: () => {}
    }
  },
  data() {
    let visible;
    return {
      visible,
      // selectAll:false,
      folderList: [],
      folderId: '',
      allList: [],
      dataList: [],
      selectedId: null, //选中的视频id
      selectedIds: [],
      pIndex: 1,
      pSize: 50,
      loadState: 0,
      checking: false,
      videoType: 1
    };
  },
  computed: {
    formatFolderList() {
      //重置list适用于banchSelect
      let arr = [{ label: '默认', value: '' }];
      this.folderList.map((item) => {
        arr.push({
          label: item.name,
          value: item.id
        });
      });
      return arr;
    },
    cardClass() {
      return this.type == '4' || this.type == '5' ? 'card-image' : 'card-video';
    }
  },
  watch: {
    value: function(val) {
      this.visible = val;
    },
    visible: async function(val) {
      this.$emit('input', val);
      if (val) {
        this.init();
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.$refs.benchSelect;
  },
  methods: {
    close() {
      this.$modal.hide('worksModal');
    },
    init() {
      this.selectedId = null;
      this.selectedIds = [];
      this.dataList = [];
      this.folderList = [];
      this.folderId = '';
      this.pIndex = 1;
      //获取文件夹列表
      this.getFolderList();
      this.getList();
    },
    typeChange(_type) {
      (this.videoType = _type), (this.folderId = '');
      this.folderList = [];
      this.selectedId = null;
      this.selectedIds = [];
      this.getFolderList();
      this.getList();
    },
    /**
     * 查询文件夹列表
     */
    async getFolderList() {
      const folderList = await this.fetchFolder(this.type, 1);
      if (folderList !== false) {
        this.folderList = folderList;
      }
    },
    folderChange(folderId) {
      this.selectedId = null;
      this.selectedIds = [];
      this.getList(folderId);
    },
    /**
     * 查询素材
     */
    async getList(folderId) {
      const params = {
        url: this.url,
        type: this.type,
        fileType: this.fileType,
        folderId: folderId,
        pageSize: 9999
      };
      if (this.videoType === 0) {
        Object.assign(params, { type: 0, fileType: 49 });
      }
      this.dataList = [];
      this.loadState = 1;
      const list = await this.fetchData(params);
      if (list !== false) {
        // if (list.length > this.pSize) {
        //   this.allList = list;

        //   console.log('获取到的视频数组', this.allList, '-------');
        //   var interval = setInterval(() => {
        //     this.add();
        //     if (this.dataList.length == this.allList.length) {
        //       clearInterval(interval);
        //       this.pIndex = 1;
        //     }
        //   }, 200);
        // } else {
        //   this.dataList = list;
        // }
        this.dataList = list;
      }
      this.dataList;
      console.log('turbo: getList -> this.dataList', this.dataList);
      this.loadState = list.length == 0 ? 3 : 0;
    },
    add() {
      // 获取数据
      let i = this.pIndex * this.pSize - this.pSize;
      let num = this.pIndex * this.pSize;
      let arr = [];
      for (i; i < num; i++) {
        if (this.allList[i]) {
          arr.push(this.allList[i]);
        }
      }
      this.dataList = [...this.dataList, ...arr];
      this.pIndex++;
    },

    changeSelect(item) {
      let isMulti = this.$route.path === '/videoConverter' || this.$route.path === '/videoMerger';
      return isMulti ? this.changeSelectMulti(item) : this.changeSelectSingle(item);
    },

    changeSelectMulti(item) {
      if (!item.selected) {
        this.selectedIds.push(item.id);
        if (this.selectedIds.length > 5) {
          this.selectedIds = this.selectedIds.slice(this.selectedIds.length - 5);
        }
        this.dataList.forEach((item) => {
          if (this.selectedIds.indexOf(item.id) > -1) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
      } else {
        item.selected = false;
        this.selectedIds = this.selectedIds.filter((v) => v !== item.id);
      }
    },

    /**
     * item 当前选择card的所有信息
     */
    changeSelectSingle(item) {
      this.dataList.forEach((target) => {
        if (item.id == target.id) {
          if (this.selectedId == item.id) {
            target.selected = false;
            this.selectedId = null;
            return;
          }
          target.selected = true;
          this.selectedId = item.id;
        } else {
          target.selected = false;
        }
      });
      //已选和全部length相等为全选
      // this.selectAll = this.selectList.length==this.dataList.length;
    },
    /**
     * 图片封面
     */
    handleImgUrl(item) {
      let path = '';
      if (item.url) {
        if (item.url.indexOf('.json') === -1) {
          path = this.$.handleAssetsUrl(item.url);
        } else {
          path = this.$.handleAssetsUrl(item.thumbnailUrl);
        }
      }
      return path;
    },
    /**
     * 模板封面
     */
    getThumbnailUrl(item) {
      if (item.thumbnailUrl) {
        let thumbnailUrlList = item.thumbnailUrl.split(',');
        return thumbnailUrlList[0];
      }
      return '';
    },
    getScreen(item) {
      if (item.screen) {
        let screenList = item.screen.split(',');
        return screenList[0];
      }
      return '';
    },
    cancel() {
      this.visible = false;
      this.$modal.hide('worksModal');
    },
    /**
     * 共享素材
     * 如在文件夹内部直接传入category:文件夹id
     */
    async submit() {
      if (this.checking) {
        return;
      }
      if (this.selectedId || this.selectedIds.length) {
        this.checking = true;
        // window.open(window.location.origin+`/tool?subtitle=true&filetype=${this.fileType}#/${this.workId}`)
        // 26为个人上传 27为个人制作
        // let data = {
        //   id: this.selectedId,
        //   fileType: 27
        // };
        let data = this.dataList.find((item) => item.id === this.selectedId);
        if (this.selectedIds.length) {
          data = this.dataList.filter((item) => {
            return this.selectedIds.indexOf(item.id) > -1;
          });
        }
        data = [].concat(data);
        const SIZE_LIMIT = 200;
        const DURATION_LIMIT = 60;
        let isExceeded = false;
        let willCheck = true;
        if (this.$route.path === '/screenshot') {
          willCheck = false;
        }
        let willCheckDuration = true;
        if (this.$route.path === '/videoConverter' || this.$route.path === '/videoMerger') {
          willCheckDuration = false;
        }
        if (data.length) {
          let tasks = data.map(async (item) => {
            let exceededInfo = false;
            var duration = item.duration;
            var size = item.size;
            // if (willCheck && size > SIZE_LIMIT * 1024 * 1024) {
            //   this.$message({
            //     message: `${item.fileType === 27 ? '我的作品:' : '视频:'}${item.title}, 大小不可超过200M`,
            //     type: 'error'
            //   });
            //   exceededInfo = { size: 'exceeded' };
            // }

            // if (willCheck && willCheckDuration && duration > DURATION_LIMIT * 60) {
            //   this.$message({
            //     message: `${item.fileType === 27 ? '我的作品:' : '视频:'}${item.title}, 时长不可超过60分钟`,
            //     type: 'error'
            //   });
            //   exceededInfo = { duration: 'exceeded' };
            // }

            let resp = await this.$http.get(`/common/material/avinfo?key=${item.url}`);
            var { data: { format: { size: _size, duration: _duration } = {} } = {} } = resp || {};
            size = _size;
            duration = _duration;
            item.size = _size;
            item.duration = _duration;
            if (willCheck && size > SIZE_LIMIT * 1024 * 1024) {
              this.$message({
                message: `${item.fileType === 27 ? '我的作品:' : '视频:'}${item.title}, 大小不可超过200M`,
                type: 'error'
              });
              exceededInfo = { size: 'exceeded' };
            }

            if (willCheck && willCheckDuration && duration > DURATION_LIMIT * 60) {
              this.$message({
                message: `${item.fileType === 27 ? '我的作品:' : '视频:'}${item.title}, 时长不可超过60分钟`,
                type: 'error'
              });
              exceededInfo = { duration: 'exceeded' };
            }
            if (duration < 1) {
              this.$message({
                message: `${item.fileType === 27 ? '我的作品:' : '视频:'}${item.title}, 时长不可小于1秒`,
                type: 'error'
              });
              exceededInfo = { duration: 'exceeded' };
            }

            return exceededInfo;
          });
          tasks = await Promise.all(tasks);
          isExceeded = tasks.some((v) => v);
        }
        if (!isExceeded && data[0]) {
          let { id, fileType } = data[0] || {};
          if (this.$route.query.id !== id) {
            this.$router.replace({ query: { id, fileType } });
          }
        }
        if (data.length === 1) {
          data = data[0];
        }

        if (!isExceeded) {
          this.$emit('chooseWork', data);
          this.onInfo(data);
        }
        setTimeout(() => {
          this.checking = false;
        }, 1300);
      } else {
        this.$message({
          message: '请选择一个视频',
          type: 'warning'
        });
      }
    },
    /**
     * 查询素材
     * @param {*} param
     */
    async fetchData(param) {
      const { data } = await this.$http.get('/user/video', {
        params: {
          fileType: param.fileType,
          fPage: param.pageSize || 36,
          sOfPage: param.pageSize || 36,
          pIndex: param.index || 1, //当前页
          type: param.type, //tab对应type
          category: param.folderId //文件夹id
        }
      });
      if (data.code === 200) {
        let arr = [];
        arr = data.data.map((item) => Object.assign(item, { selected: false }));
        return arr;
      } else {
        return false;
      }
    },
    /**
     * 查询文件夹列表
     * @param {*} type 对应类型
     * @param {*} ourself 是否个人列表
     */
    async fetchFolder(type, ourself) {
      let params = { type: type, ourself: ourself };
      if (this.videoType === 0) {
        Object.assign(params, { fileType: 49 });
      }
      const { data } = await this.$http.get('/user/material/category', { params });
      if (data.code == 200) {
        return data.data;
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'modal';
.wb-tool-works-diaolog-body {
  position: relative;
  padding: 40px 39px;
  height: 446px;
  .title {
    margin-bottom: 23px;
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    text-align: center;
  }
  .head {
    display: flex;
    margin-top: 23px;
    justify-content: space-between;
  }
  .wb-tool-works-diaolog-container {
    margin-top: 25px;
    margin-right: auto;
    margin-left: auto;
    height: 263px;
    overflow: auto;
    width: 527px;
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      // border-radius: 2px;
      background-color: #f6f6fcd3;
    }
    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      // border-radius: 2px;
      background-color: #959595;
    }
  }
  .wb-tool-works-diaolog-list {
    display: flex;
    flex-flow: wrap;
    .wb-tool-works-diaolog-card {
      position: relative;
      margin-bottom: 18px;
      box-sizing: border-box;
      &.card-image {
        margin-right: 21px;
        width: 88px;
        &:nth-child(5n) {
          margin-right: 0;
        }
        .card-poster {
          width: 88px;
          height: 88px;
          .poster-img {
            margin-bottom: 2px;
            max-width: 100%;
          }
        }
      }
      &.card-video {
        margin-right: 18px;
        width: 118px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .card-poster {
          width: 118px;
          height: 71px;
          .poster-img-p {
            position: absolute;
            width: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }
          &.card-poster-video {
            display: block;
          }
          .poster-img-v {
            position: relative;
            width: 118px;
            height: 71px;
            filter: blur(10px);
          }
          .poster-img-v-c {
            position: absolute;
            top: 0;
            left: 50%;
            margin: 0 auto;
            max-width: 118px;
            height: 71px;
            transform: translate(-50%, 0);
            z-index: 2;
          }
        }
      }
      .card-poster {
        position: relative;
        display: flex;
        margin-bottom: 2px;
        border: 1px solid #f1f3f7;
        // border-radius:4px;
        overflow: hidden;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        .card-during {
          position: absolute;
          right: 5px;
          bottom: 6px;
        }
      }
      .card-title {
        margin-top: 5px;
        text-align: left;
        height: 14px;
        padding-bottom: 2px;
        line-height: 12px;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .card-select {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 3;
      }
    }
  }
  .wb-tool-works-diaolog-state {
    height: 295px;
  }
  .wb-tool-works-diaolog-footer {
    display: flex;
    margin: 46px auto 20px;
    width: 273px;
    justify-content: space-between;
  }
}

.close-btn {
  width: 12px;
  height: 12px;
  cursor: pointer;
  color: #666666;
  &:hover {
    color: #9e9e9e;
  }
}
</style>
<style lang="scss">
.wb-tool-works-diaolog-body {
  .wb-tool-works-diaolog-select {
    height: 26px;
    .el-input__inner {
      height: 26px;
      line-height: 26px;
    }
  }
  .wb-tool-works-diaolog-select .el-checkbox__input {
    &.is-checked .el-checkbox__inner {
      background-color: #3058fe;
      border-color: #3058fe;
    }
    .el-checkbox__inner {
      display: flex;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
      border-color: #999;
      &::after {
        left: 6px;
        width: 4px;
        height: 11px;
      }
    }
  }
}
</style>
